import FormReport from "../../../../../components/pages/FormReport";
import { useFetch } from '../../../../../hooks/useFetch';
import { Tabs } from 'antd';

export default () => { // eslint-disable-line

    return (
        <Tabs defaultActiveKey="daily" destroyInactiveTabPane>
            <Tabs.TabPane tab="Daily" key="daily">
                <FormReport
                    title={'Hold Release Reports'}
                    repType={'daily'}
                    url={"/api/v1/report_hold_releases"}
                    FetchComponent={useFetch}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Monthly" key="monthly">
                <FormReport
                    title={'Hold Release Reports'}
                    repType={'monthly'}
                    url={"/api/v1/report_hold_releases"}
                    FetchComponent={useFetch}
                />
            </Tabs.TabPane>
        </Tabs>
    )
}
